import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import searchPagePlugin from '@backstage/plugin-search/alpha';
import SearchIcon from '@material-ui/icons/Search';

const searchPageOverride = PageBlueprint.make({
  params: {
    path: '/search',
    routeRef: searchPagePlugin.routes.root,
    loader: () => import('./SearchPage').then(m => <m.SearchPage />),
    title: 'Search',
    icon: <SearchIcon />,
  },
});

export const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [searchPageOverride],
});
